export interface CaseLabels {
  [caseId: string]: { labels: Label[]; slides: SlideLabels };
}

export interface SlideLabels {
  [slideId: string]: { labels: Label[] };
}

export interface Label {
  key: string;
  likelihood: Likelihood;
  title?: string;
}

export enum Likelihood {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}
